
export enum ServerOptions {
    RULE_SERVER = 'casa-rule-server',
    API_SERVER = 'api-server',
    IOT_WEB_API = 'iot-web-api',
}

export enum SortParamOptions {
  OVERALL_COUNT = 'overallCount',
  AVERAGE_TIME = 'averageTime',
  SLOW_REQUESTS = 'slowRequests',
  FAILURE_COUNT = 'failureCount',
  SUCCESS_COUNT = 'successCount'
}